export const translations = {
  he: {
    // Auth
    expertsDashboard: 'המומחים של GroupHug',
    login: 'התחברות',
    register: 'הרשמה',
    email: 'כתובת מייל',
    password: 'סיסמה',
    passwordHelp: 'חייבת להכיל אותיות ומספרים, לפחות 6 תווים',
    firstName: 'שם פרטי',
    lastName: 'שם משפחה',
    phone: 'טלפון',
    verificationCode: 'קוד אימות',
    verificationSent: 'שלחנו לך קוד אימות לאימייל',
    verify: 'אימות',
    noAccount: 'עדיין אין לך חשבון? לחץ/י כאן',
    hasAccount: 'כבר יש לך חשבון? לחץ/י כאן',
    forgotPassword: 'שכחת סיסמא?',
    noProfile: 'אין לך פרופיל עדיין',

    // Reset password
    resetPassword: 'איפוס סיסמה',
    resetEmailSent: 'שלחנו לך אימייל לאיפוס הסיסמה',
    redirectingToLogin: 'מיד נעביר אותך למסך ההתחברות',
    reset: 'איפוס',

    // Main navigation
    loading: 'שניה, טוענים...',
    logout: 'התנתק',

    // Tabs
    tabProfile: 'הפרופיל שלי',
    tabWorkingHours: 'זמני פעילות',
    tabMeetingsCalendar: 'יומן פגישות',
    tabReviews: 'משובים',
    tabPayments: 'תשלומים',
    tabGroupSessions: 'הרצאות וסדנאות אונליין',
    tabCalendarSync: 'סינכרון יומן',
    tabInfoPage: 'דף מידע',

    // Expert Profile
    expertProfile: 'פרופיל מומחה',
    myProfileLink: 'קישור לעמוד שלי',
    name: 'שם',
    nameEnglish: 'שם באנגלית',
    vatStatus: 'חייב במע"מ',
    authorizedDealer: 'עוסק מורשה',
    exemptDealer: 'עוסק פטור',
    contact: 'יצירת קשר',
    emailPlaceholder: 'מייל',
    phonePlaceholder: 'טלפון',
    titleLabel: 'טייטל',
    titleEnglish: 'טייטל באנגלית',
    descriptionLabel: 'תיאור',
    descriptionEnglish: 'תיאור באנגלית',
    zoom: 'זום',
    zoomLink: 'קישור קבוע',
    zoomPassword: 'סיסמה',
    clinicCity: 'עיר הקליניקה',
    clinicCityNote: 'יופיע בראש עמוד הפרופיל שלכם',
    bankDetails: 'פרטי בנק',
    accountNumber: 'מספר חשבון',
    bankName: 'שם בנק',
    branchNumber: 'מספר סניף',
    certificates: 'אישורים ותעודות',
    insuranceCertificate: 'תעודת ביטוח מקצועית',
    noInsurance: 'אין תעודה',
    viewPDF: 'צפה בקובץ PDF',
    insuranceExpiry: 'תאריך תפוגת ביטוח',
    save: 'שמירה',

    // Working Hours
    myWorkingHours: 'שעות הפעילות שלי',
    sunday: 'ראשון',
    monday: 'שני',
    tuesday: 'שלישי',
    wednesday: 'רביעי',
    thursday: 'חמישי',
    friday: 'שישי',
    saturday: 'שבת',
    addHoursDialogTitle: 'הוספת שעות פעילות - יום',
    start: 'התחלה',
    end: 'סיום',
    service: 'שירות',
    selectServices: 'בחר שירותים',
    allServices: 'כל השירותים',
    workingHoursUpdated: 'שעות הפעילות עודכנו',
    setVacation: 'הגדרת חופשה',
    vacationDefined: 'חופשה מוגדרת:',
    vacationStart: 'התחלה:',
    vacationEnd: 'סיום:',
    vacationDeleted: 'חופשה נמחקה בהצלחה',
    vacationSet: 'חופשה נקבעה בהצלחה',
    finishedSettingProfile: 'סיימתי להגדיר את הפרופיל שלי!',

    // Private Services
    editService: 'עריכת שירות',
    titleHebrew: 'כותרת עברית',
    titleEnglishService: 'כותרת אנגלית',
    descriptionHebrew: 'תיאור עברית',
    descriptionEnglishService: 'תיאור אנגלית',
    serviceDuration: 'משך השירות',
    breakAfterSession: 'הפסקה לאחר מפגש',
    price: 'מחיר',
    priceBeforeDiscount: 'מחיר לפני הנחה',
    minutes: 'דקות',
    cancel: 'ביטול',
    serviceUpdated: 'השירות עודכן',
    paidSession: 'מפגש ללקוחות בתשלום',
    subscriberSession: 'מפגש למנויי GroupHug',
    isSeries: 'הפוך את השירות לסדרה (חבילת פגישות)',
    seriesSize: 'מספר פגישות בסדרה',

    // Reviews
    noReviews: 'עדיין אין משובים כאן',
    avgRating: 'ממוצע דירוג',
    privateSessionLabel: 'פרטני',
    reviewsPerPage: 'מספר משובים בעמוד:',

    // Payments
    bankDetailsNote: 'יש להעביר פרטי חשבון בנק מלאים להנהלת החשבונות office@grouphug.online.',
    paymentInvoiceNote: 'לאחר קבלת התשלום לחשבונך יש לשלוח קבלה / חשבונית לאותו המייל, עבור גרופהאג אונליין בע"מ ח.פ. 516312865',
    noDataForMonth: 'עדיין אין נתונים לחודש',
    updateData: 'עדכון נתונים',
    total: 'סה"כ',
    vatNote: 'הוספת המע״מ, לעוסק מורשה, תתבצע אוטומטית עבור הרצאות, סדנאות ושיחות הכוונה.',
    lastUpdated: 'עדכון אחרון:',
    canUpdateOncePerHour: 'ניתן לעדכן רק פעם בשעה',
    consultationSessions: 'שיחות הכוונה',
    oneToOneSessionsLabel: 'מפגשים פרטניים',
    groupSessionsLabel: 'הרצאות וסדנאות',
    safeSpace: 'מרחב בטוח',
    clearingFeeNote: 'כולל 3% עמלת סליקה',
    clearingFeeFullNote: 'כולל 3% עמלת סליקה עבור טיפולים במחיר מלא',

    // Month Selection
    resetToCurrentMonth: 'איפוס לחודש נוכחי',
    previousMonth: 'חודש קודם',
    nextMonth: 'חודש הבא',

    // Group Sessions
    upcomingLectures: 'הרצאות וסדנאות עתידיות',
    pastLectures: 'הרצאות וסדנאות עבר',
    groupServices: 'שירותים קבוצתיים',

    // One to One Sessions
    oneToOneTitle: 'מפגשים אחד על אחד',
    scheduleAppointmentWith: 'קביעת פגישה עם',
    sessionScheduled: 'המפגש נקבע בהצלחה',

    // Google Calendar
    googleCalendarDescription:
      'In order to show users time slots open for booking, it is necessary to connect your account to Google Calendar. This sync will only take / show "free" / "busy" slots and is not showing any personal schedule and details.',
    googleCalendarPolicy: "Group Hug's use and transfer of information received from Google APIs to any other app will adhere to",
    googleCalendarPolicyLink: 'Google API Services User Data Policy',
    connected: 'מחובר',
    syncFailed: 'הסינכרון לא הושלם בהצלחה\nיש לבצע סינכרון מחדש ולוודא שמסמנים את תיבות הסימון המאשרות גישה ליומן',
    notConnected: 'לא מחובר',

    // Chatbot
    chatbotLabel: 'משהו לא ברור?\nשאלו אותי',
    chatTitle: "צ'אט עם AI",
    chatWelcome: 'היי, אני צאט תמיכה לכל אנשי המקצוע של GroupHug. את.ה יכול.ה לשאול אותי כל מה שתרצי.ה.\nלדוגמא: ״מתי אקבל את התשלום הקרוב?״ או ״קבעו איתי שיחה, מה עלי לעשות עכשיו״?',
    chatThinking: 'חושב...',
    chatPlaceholder: 'הקלד את השאלה שלך...',
    chatNoAnswer: 'לא התקבלה תשובה',
    chatError: 'אירעה שגיאה בשליחת ההודעה',

    // Alerts
    missingExpertId: 'חסר מזהה מומחה',
    requestSent: 'הבקשה נשלחה בהצלחה',
    somethingWentWrong: 'משהו השתבש',
    profileUpdated: 'הפרופיל עודכן בהצלחה!',
    titleUpdated: 'הטייטל עודכן בהצלחה!',
    descriptionUpdated: 'התיאור עודכן בהצלחה!',
    zoomUpdated: 'פרטי הזום עודכנו בהצלחה!',
    locationUpdated: 'עיר הקליניקה עודכנה בהצלחה!',
    bankUpdated: 'פרטי הבנק עודכנו בהצלחה!',
    vatStatusUpdated: 'סטטוס המע"מ עודכן בהצלחה!',
  },
  en: {
    // Auth
    expertsDashboard: 'GroupHug Experts',
    login: 'Login',
    register: 'Register',
    email: 'Email address',
    password: 'Password',
    passwordHelp: 'Must contain letters and numbers, at least 6 characters',
    firstName: 'First name',
    lastName: 'Last name',
    phone: 'Phone',
    verificationCode: 'Verification code',
    verificationSent: 'We sent you a verification code to your email',
    verify: 'Verify',
    noAccount: "Don't have an account? Click here",
    hasAccount: 'Already have an account? Click here',
    forgotPassword: 'Forgot password?',
    noProfile: "You don't have a profile yet",

    // Reset password
    resetPassword: 'Reset Password',
    resetEmailSent: 'We sent you an email to reset your password',
    redirectingToLogin: 'Redirecting you to the login screen shortly',
    reset: 'Reset',

    // Main navigation
    loading: 'Loading...',
    logout: 'Logout',

    // Tabs
    tabProfile: 'My Profile',
    tabWorkingHours: 'Working Hours',
    tabMeetingsCalendar: 'Meetings Calendar',
    tabReviews: 'Reviews',
    tabPayments: 'Payments',
    tabGroupSessions: 'Online Lectures & Workshops',
    tabCalendarSync: 'Calendar Sync',
    tabInfoPage: 'Info Page',

    // Expert Profile
    expertProfile: 'Expert Profile',
    myProfileLink: 'My Profile Link',
    name: 'Name',
    nameEnglish: 'English Name',
    vatStatus: 'VAT Status',
    authorizedDealer: 'Authorized dealer',
    exemptDealer: 'Exempt dealer',
    contact: 'Contact',
    emailPlaceholder: 'Email',
    phonePlaceholder: 'Phone',
    titleLabel: 'Title',
    titleEnglish: 'English Title',
    descriptionLabel: 'Description',
    descriptionEnglish: 'English Description',
    zoom: 'Zoom',
    zoomLink: 'Permanent link',
    zoomPassword: 'Password',
    clinicCity: 'Clinic City',
    clinicCityNote: 'Will appear at the top of your profile page',
    bankDetails: 'Bank Details',
    accountNumber: 'Account number',
    bankName: 'Bank name',
    branchNumber: 'Branch number',
    certificates: 'Certificates & Approvals',
    insuranceCertificate: 'Professional insurance certificate',
    noInsurance: 'No certificate',
    viewPDF: 'View PDF file',
    insuranceExpiry: 'Insurance expiry date',
    save: 'Save',

    // Working Hours
    myWorkingHours: 'My Working Hours',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    addHoursDialogTitle: 'Add working hours - day',
    start: 'Start',
    end: 'End',
    service: 'Service',
    selectServices: 'Select services',
    allServices: 'All services',
    workingHoursUpdated: 'Working hours updated',
    setVacation: 'Set vacation',
    vacationDefined: 'Vacation defined:',
    vacationStart: 'Start:',
    vacationEnd: 'End:',
    vacationDeleted: 'Vacation deleted successfully',
    vacationSet: 'Vacation set successfully',
    finishedSettingProfile: 'I finished setting up my profile!',

    // Private Services
    editService: 'Edit Service',
    titleHebrew: 'Hebrew title',
    titleEnglishService: 'English title',
    descriptionHebrew: 'Hebrew description',
    descriptionEnglishService: 'English description',
    serviceDuration: 'Service duration',
    breakAfterSession: 'Break after session',
    price: 'Price',
    priceBeforeDiscount: 'Price before discount',
    minutes: 'min',
    cancel: 'Cancel',
    serviceUpdated: 'Service updated',
    paidSession: 'Session for paying clients',
    subscriberSession: 'Session for GroupHug subscribers',
    isSeries: 'Make this service a series (session package)',
    seriesSize: 'Number of sessions in series',

    // Reviews
    noReviews: 'No reviews yet',
    avgRating: 'Average rating',
    privateSessionLabel: 'Private',
    reviewsPerPage: 'Reviews per page:',

    // Payments
    bankDetailsNote: 'Please send full bank account details to accounting: office@grouphug.online.',
    paymentInvoiceNote:
      'After receiving the payment, please send a receipt / invoice to the same email, for GroupHug Online Ltd. VAT 516312865',
    noDataForMonth: 'No data yet for month',
    updateData: 'Update data',
    total: 'Total',
    vatNote: 'VAT will be added automatically for authorized dealers, for lectures, workshops and consultation calls.',
    lastUpdated: 'Last updated:',
    canUpdateOncePerHour: 'Can only update once per hour',
    consultationSessions: 'Consultation sessions',
    oneToOneSessionsLabel: 'One-on-one sessions',
    groupSessionsLabel: 'Lectures & Workshops',
    safeSpace: 'Safe space',
    clearingFeeNote: 'Includes 3% clearing fee',
    clearingFeeFullNote: 'Includes 3% clearing fee for full-price treatments',

    // Month Selection
    resetToCurrentMonth: 'Reset to current month',
    previousMonth: 'Previous month',
    nextMonth: 'Next month',

    // Group Sessions
    upcomingLectures: 'Upcoming Lectures & Workshops',
    pastLectures: 'Past Lectures & Workshops',
    groupServices: 'Group Services',

    // One to One Sessions
    oneToOneTitle: 'One-on-one sessions',
    scheduleAppointmentWith: 'Schedule appointment with',
    sessionScheduled: 'Session scheduled successfully',

    // Google Calendar
    googleCalendarDescription:
      'In order to show users time slots open for booking, it is necessary to connect your account to Google Calendar. This sync will only take / show "free" / "busy" slots and is not showing any personal schedule and details.',
    googleCalendarPolicy: "Group Hug's use and transfer of information received from Google APIs to any other app will adhere to",
    googleCalendarPolicyLink: 'Google API Services User Data Policy',
    connected: 'Connected',
    syncFailed:
      'Sync did not complete successfully\nPlease sync again and make sure to check the boxes that authorize calendar access',
    notConnected: 'Not connected',

    // Chatbot
    chatbotLabel: 'Something unclear?\nAsk me',
    chatTitle: 'AI Chat',
    chatWelcome: "Hi, I'm a support chat for all GroupHug professionals. You can ask me anything you'd like.\nFor example: \"When will I receive my next payment?\" or \"Someone scheduled a session with me, what do I do now?\"",
    chatThinking: 'Thinking...',
    chatPlaceholder: 'Type your question...',
    chatNoAnswer: 'No answer received',
    chatError: 'An error occurred while sending the message',

    // Alerts
    missingExpertId: 'Missing expert ID',
    requestSent: 'Request sent successfully',
    somethingWentWrong: 'Something went wrong',
    profileUpdated: 'Profile updated successfully!',
    titleUpdated: 'Title updated successfully!',
    descriptionUpdated: 'Description updated successfully!',
    zoomUpdated: 'Zoom details updated successfully!',
    locationUpdated: 'Clinic city updated successfully!',
    bankUpdated: 'Bank details updated successfully!',
    vatStatusUpdated: 'VAT status updated successfully!',
  },
};

export type TranslationKey = keyof typeof translations.he;
